import routeHandler from './routes';
import MODULE_ID from './moduleId';

const module = {
  moduleType: 'ELearning', // Type used in module configuration
  moduleId: MODULE_ID,
  api: 'elearning',
  path: 'elearning',

  routeHandler,
};
export default module;
